var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 8.86H12.675c-2.15 0-3.892 2.174-3.892 4.856v2.429",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.108 13.714L23 8.857 19.108 4M14.62 13.107v6.679c0 .67-.435 1.214-.972 1.214H1.973C1.436 21 1 20.456 1 19.786V5.216C1 4.544 1.436 4 1.973 4h11.675c.537 0 .973.544.973 1.214v.607",
    stroke: "current",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjQgMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yMyA4Ljg1OTI1SDEyLjY3NDdDMTAuNTI1NSA4Ljg1OTI1IDguNzgzMTcgMTEuMDMzNyA4Ljc4MzE3IDEzLjcxNjFWMTYuMTQ0NSIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOS4xMDg1IDEzLjcxMzZMMjMgOC44NTY4MkwxOS4xMDg1IDQiIHN0cm9rZT0iY3VycmVudCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTQuNjIwNSAxMy4xMDc1VjE5Ljc4NTZDMTQuNjIwNSAyMC40NTYyIDE0LjE4NDkgMjAuOTk5OCAxMy42NDc2IDIwLjk5OThIMS45NzI4OUMxLjQzNTU4IDIwLjk5OTggMSAyMC40NTYyIDEgMTkuNzg1NlY1LjIxNTEyQzEgNC41NDQ1MyAxLjQzNTU4IDQuMDAwOTIgMS45NzI4OSA0LjAwMDkySDEzLjY0NzZDMTQuMTg0OSA0LjAwMDkyIDE0LjYyMDUgNC41NDQ1MyAxNC42MjA1IDUuMjE1MTJWNS44MjIyMiIgc3Ryb2tlPSJjdXJyZW50IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";
export { SvgTransfer as ReactComponent };